import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@environment';
import saveAs from 'file-saver';

import { TemplateTypes } from '../enums';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {

    readonly environment = inject(ENVIRONMENT);
    readonly http: HttpClient = inject(HttpClient);

    path: string = this.environment.apiUrl + 'Download/';

    public downloadTemplate = (type: TemplateTypes) => {
        return this.downloadFile(`${this.path}Template/${type}`, undefined, 'template.xlsm');
    };

    public downloadFile(path: string, params?: any, fileName?: string, completeCallback?: (() => void)) {

        return this.http
            .get(`${path}`, {
                params,
                responseType: 'blob',
                observe: 'response',
            })
            .subscribe({
                next: (res) => {
                    fileName = this.getFileNameFromDisposition(res.headers) ?? fileName;

                    saveAs(res.body!, fileName);
                },
                complete: completeCallback
            });
    }



    private getFileNameFromDisposition(headers: HttpHeaders): string | null {

        const contentDisposition = headers.get('content-disposition');
        if (!contentDisposition) return null;

        const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(contentDisposition);
        const fileName = decodeURIComponent(match?.[1] ?? match?.[2] ?? '');
        return fileName || null;
    }
}
